











import { CatImage } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HelloWorld extends Vue {
  @Prop() private cats!: CatImage;
}
